import { Column } from 'src/components/table/CustomTable.interface';
import { DeleteBundleAction } from 'src/features/locations/calendarLocationGroupPage/modules/CalendarView/eventContentSidebar/EventContentSidebar.interface';
import {
  IDaypart,
  ILocation,
  ILocationGroup,
  IMappedLocationGroupDaypart,
  ProjectConfigInterface,
} from 'src/interfaces';
import { ISchedule, IScheduleItem } from 'src/interfaces/Schedule';

export interface LocationSchedulePageTableProps {
  isDefaultLocationGroup?: boolean;
  locationGroup?: ILocationGroup;
  locationGroupScheduleLoading: boolean;
  totalCount: number;
  tableData: IMappedLocationGroupDaypart[] | ISchedule[];
  columns: Column[];
  expandedColumns?: Column[];
  onChangeLocationGroup?: (
    event: React.SyntheticEvent,
    newValue: string,
  ) => void;
  locationData?: ILocation;
  refetchSchedules?: () => void;
  isLocationGroupSchedule?: boolean;
  page: number;
  totalPage: number;
  onPageChange: (event: React.ChangeEvent<unknown>, newPage: number) => void;
  selectedDaypartId: number;
  selectedPositionId: string;
  daypartOptions: IDaypart[];
  isLoadingDayparts: boolean;
  onDaypartChange: (id: number) => void;
  onPositionChange: (id: string) => void;
  selectedOption: string;
  onSelectedOptionChange: (value: string) => void;
  projectConfig?: Partial<ProjectConfigInterface>;
  sortDirection: { key: string; direction: string; isSortModified: boolean };
  handleSortingClick: (key: string, direction: string) => void;
  rowsPerPage: number;
  onRowsPerPageChange: (value: number) => void;
  deleteBundleAction: DeleteBundleAction;
  locationsCount?: number;
  shouldShowListview?: {
    daypartDisabled: boolean;
    noScheduleComponent: boolean;
    noDefaultAssembly: boolean;
    previewDisable?: boolean;
  };
}

export const VIEW_OPTIONS = {
  DEFAULT_ASSEMBLY: 'default_assembly',
  SCHEDULE_COMPONENT: 'schedule_component',
};
export enum MenuContext {
  SCHEDULE = 'schedule',
  COMPONENT = 'component',
}

export type SelectedRow = {
  scheduleId: number;
  scheduleName: string;
  scheduleItemId?: number;
  componentName?: string;
  context: MenuContext;
  scheduleItems?: IScheduleItem[];
};
